












import { Component, Vue } from 'vue-property-decorator';
import Classroom from '@/services/Classroom';

@Component
export default class DeleteClassroom extends Vue {
  classroomId = '';

  mounted() {
    this.classroomId = this.$route.params.id;
  }

  async deleteClassroom(e: any) {
    e.preventDefault();
    await Classroom.deleteClassroom(this.classroomId);
    this.closeModal();
  }

  closeModal() {
    this.$parent.$emit('close-modal');
  }
}
